"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var DefaultFormatter_1 = require("./DefaultFormatter");
var BodyCell_1 = require("./BodyCell");
var RowHeaderCell = /** @class */ (function (_super) {
    __extends(RowHeaderCell, _super);
    function RowHeaderCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderHeaderRowHeaderCell = function () {
            var outerAttrs = {
                className: 'tb-react-dg-hcol',
                style: { width: RowHeaderCell.Width }
            };
            var pointerEventWrapperProps = {
                pointerClick: _this.props.onRowHeaderCellClick
            };
            var innerAttrs = {
                'data-tb-test-id': "" + _this.props.testId + RowHeaderCell.CellTestIdSuffix,
                className: 'tb-react-dg-hcell tb-react-dg-hcell-resizable'
            };
            var dividerStyle = {
                bottom: 0,
                position: 'absolute',
                top: 0
            };
            return (React.createElement("div", __assign({}, outerAttrs),
                React.createElement(widgets_1.PointerEventWrapper, __assign({}, pointerEventWrapperProps),
                    React.createElement("div", __assign({}, innerAttrs))),
                React.createElement("div", { style: dividerStyle })));
        };
        _this.renderBodyRowHeaderCell = function () {
            var pointerEventWrapperProps = {
                pointerClick: _this.props.onRowHeaderCellClick
            };
            var style = BodyCell_1.BodyCell.getDefaultStyle(_this.props.height, RowHeaderCell.Width, true);
            var content = React.createElement(DefaultFormatter_1.DefaultFormatter, { value: '', testId: "" + _this.props.testId + RowHeaderCell.CellTestIdSuffix + "-Cell" });
            var attrs = {
                'aria-selected': _this.props.isSelected,
                'data-tb-test-id': "" + _this.props.testId + RowHeaderCell.CellTestIdSuffix,
                style: style
            };
            return (React.createElement(widgets_1.PointerEventWrapper, __assign({}, pointerEventWrapperProps),
                React.createElement("div", __assign({}, attrs), content)));
        };
        return _this;
    }
    RowHeaderCell.prototype.render = function () {
        return (this.props.rowType === RowHeaderCell.RowType.Header) ? this.renderHeaderRowHeaderCell() : this.renderBodyRowHeaderCell();
    };
    RowHeaderCell.displayName = 'DataGridRowHeaderCell';
    RowHeaderCell.element = React.createFactory(RowHeaderCell);
    return RowHeaderCell;
}(React.PureComponent));
exports.RowHeaderCell = RowHeaderCell;
(function (RowHeaderCell) {
    RowHeaderCell.CellTestIdSuffix = '-rowHeaderCell';
    RowHeaderCell.Width = 10;
    var RowType;
    (function (RowType) {
        RowType[RowType["Header"] = 0] = "Header";
        RowType[RowType["Body"] = 1] = "Body";
    })(RowType = RowHeaderCell.RowType || (RowHeaderCell.RowType = {}));
})(RowHeaderCell = exports.RowHeaderCell || (exports.RowHeaderCell = {}));
exports.RowHeaderCell = RowHeaderCell;
//# sourceMappingURL=RowHeaderCell.js.map